<template lang="pug">
.search-result
  .search-result__content
    a.search-result__title(:href="result.url") {{ result.title }}
    small.search-result__date {{ result.meta.category }} - {{ date }}
    p.search-result__summary {{ result.summary }}
</template>

<script>
export default {
  name: "OCCResult",
  props: {
    result: Object,
    openInNewWindow: Boolean,
    formatDate: Function,
  },
  computed: {
    date() {
      return this.formatDate(this.result.itemDate, "MMM. dd, yyyy");
    },
  },
};
</script>
<style lang="scss" scoped>
.search-result {
  &:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 1.5rem;
  }

  &__title {
    font-weight: 600;
  }

  &__date {
    margin: .25rem 0 1rem 0;
    padding: 0;
    display: block;
    white-space: nowrap;
    font-size: .75rem;
    text-transform: uppercase;
    line-height: 1;
    font-weight: 700;
    opacity: .5;
  }

  &__summary {
    margin: 0;
  }
}
</style>